import {
  SEARCH_CLIENTS,
  SEARCH_CLIENTS_SUCCESS,
  AUTOCOMPLETE_CLIENTS,
  AUTOCOMPLETE_CLIENTS_SUCCESS,
  AUTOCOMPLETE_MY_CLIENTS,
  AUTOCOMPLETE_MY_CLIENTS_SUCCESS,
  CLEAR_AUTOCOMPLETE_CLIENTS,
  SEARCH_MY_CLIENTS,
  SEARCH_MY_CLIENTS_SUCCESS,
  EXPORT_MY_CLIENTS,
  EXPORT_MY_CLIENTS_SUCCESS,
  EXPORT_MY_CLIENTS_ERROR,
} from '../constants/ActionsTypes'

const initialState = {
  myClientsSearch: null,
  myClientsSearchRequest: {},
  isLoadingMyClients: false,
  isExporting: false,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_CLIENTS:
      return { ...state, searchRequest: action.payload }
    case SEARCH_CLIENTS_SUCCESS:
      return { ...state, search: action.payload.response }
    case AUTOCOMPLETE_CLIENTS:
      return { ...state, autocompleteData: null }
    case AUTOCOMPLETE_CLIENTS_SUCCESS:
      return { ...state, autocompleteData: action.payload }
    case AUTOCOMPLETE_MY_CLIENTS:
      return { ...state, autocompleteData: null }
    case AUTOCOMPLETE_MY_CLIENTS_SUCCESS:
      return { ...state, autocompleteData: action.payload }
    case CLEAR_AUTOCOMPLETE_CLIENTS:
      return { ...state, autocompleteData: null }
    case SEARCH_MY_CLIENTS:
      return { ...state, myClientsSearchRequest: action.payload, isLoadingMyClients: true }
    case SEARCH_MY_CLIENTS_SUCCESS:
      return { ...state, myClientsSearch: action.payload.response, isLoadingMyClients: false }
    case EXPORT_MY_CLIENTS:
      return { ...state, isExporting: true }
    case EXPORT_MY_CLIENTS_SUCCESS:
      return { ...state, isExporting: false }
    case EXPORT_MY_CLIENTS_ERROR:
      return { ...state, isExporting: false }
    default:
      return state
  }
}

export default rootReducer
